'use strict';

var app = require('angular').module('app');


app.controller('headerController', require('./headerController'));
app.controller('downloadController', require('./downloadController'));
app.controller('footerController', require('./footerController'));

app.controller('homeController', require('./homeController'));
app.controller('newsroomController', require('./newsroomController'));
app.controller('articleController', require('./articleController'));

// app.controller('videoController', require('./videoController'));
app.controller('carouselController', require('./carouselController'));
app.controller('feedController', require('./feedController'));
app.controller('featureVideoController', require('./featureVideoController'));
app.controller('redirectController', require('./redirectController'));

// app.controller('videoWatchController', require('./videoWatchController'));


